module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-redes-sociais-facebook-768x591.e1bcb9ec.jpg";